import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import _, { cloneDeep } from 'lodash';

import itemStatusColor from '@/common/constant/ItemStatusColor';

import { validateItemListFieldStatus } from '@/component/formManagement/handler/FieldListHandler';
import { deleteForm } from '@/service/formManagementService';
import { I18n } from 'aws-amplify';
import { validateNameOfField } from './CommonHandler';

export const isAddNewItem = (item, argsAll) => {
    if (Utils.findIndexInArrayById(item.id, argsAll.createdItemList) === -1) {
        return true;
    }
    return false;
};

export const enableDeleteItem = (item) => {
    if (item?.structure?.isUsingItem) {
        return false;
    }
    return true;
};

/**
 * duplicate status item
 * @param {*} itemId
 */
export const duplicateItem = (itemId, argsAll) => {
    if (!Utils.isEmptyArray(argsAll.itemList)) {
        let currentItemList = cloneDeep(argsAll.itemList);
        let index = Utils.findIndexInArrayById(itemId, currentItemList);
        let newItem = cloneDeep(currentItemList[index]);
        newItem.id = Date.now().toString();
        newItem.isShowInfo = true;
        newItem.name[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, newItem.name)} - Copy`,
        };
        newItem.viewForCustomer[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: `${Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                newItem.viewForCustomer
            )} - Copy`,
        };
        newItem.errorMsg = {};

        // push to list
        currentItemList.splice(index + 1, 0, newItem);
        argsAll.setItemList(currentItemList);
    }
};

/**
 * reOrder item list
 * @param {*} list
 * @returns new list
 */
export const reOrderItemList = (list) => {
    let newList = [];

    for (let [index, item] of list.entries()) {
        item.structure.no = index + 1;
        newList.push(item);
    }

    return newList;
};

/**
 * onchange using item
 * @param {*} event
 * @param {*} field
 * @param {*} argsAll
 * @param {*} isUsingItem
 * update item list
 */
export const onChangeUsingItem = (event, field, argsAll, isUsingItem) => {
    let itemUsingList = cloneDeep(argsAll.itemUsingList);
    let itemNotUsingList = cloneDeep(argsAll.itemNotUsingList);
    let fieldData = cloneDeep(field);

    fieldData.structure.isUsingItem = isUsingItem;
    if (isUsingItem) {
        let indexInNotUsingList = Utils.findIndexInArrayById(fieldData.id, itemNotUsingList);
        if (indexInNotUsingList === -1) {
            return;
        }
        itemNotUsingList = Utils.removeItemInArrayById(fieldData.id, itemNotUsingList);
        itemUsingList.push(fieldData);
    } else {
        let indexInUsingList = Utils.findIndexInArrayById(fieldData.id, itemUsingList);
        if (indexInUsingList === -1) {
            return;
        }
        itemUsingList = Utils.removeItemInArrayById(fieldData.id, itemUsingList);
        itemNotUsingList.push(fieldData);
    }

    let newItemList = itemUsingList.concat(itemNotUsingList);
    newItemList = reOrderItemList(newItemList);
    argsAll.setItemList(newItemList);
};

/**
 * onCancelSaveItemList - Handler for 閉じる button
 * @returns
 */
export const onCancelSaveItemList = (argsAll, props) => {
    if (argsAll.isDisableBtnSave && !isChangeItemListData(argsAll.itemList, argsAll.itemListDefault)) {
        props.setPanelScreen(props.parentPanelScreen);
        return;
    }
    // Set isCloseScreen flag for 閉じる button
    props?.setFormPanelTabClose(prev => ({
        ...prev,
        isDirty: true,
        isCloseScreen: true
    }));
    props?.setIsOpenUnsavedChangesDialog(true);
};

/**
 * save item list
 * @param {*} argsAll
 * @param {*} props
 * @returns
 */
export const onSubmitSaveItemList = (argsAll, props) => {
    let validateResult = validateItemListFieldStatus(argsAll.itemList);

    if (!validateResult.status) {
        let newItemList = [...validateResult.itemList];
        argsAll.setItemList(newItemList);
        return;
    }

    let newItemList = [...validateResult.itemList];

    // Update currentUpdateField
    let currentField = cloneDeep(argsAll.currentField);
    currentField = { ...currentField, itemList: newItemList };
    props.setCurrentUpdateField(currentField);

    // Update in fieldAddList
    let currentFieldAddList = cloneDeep(props.fieldAddList);
    let indexInFieldAddList = Utils.findIndexInArrayById(currentField.id, currentFieldAddList);
    if (indexInFieldAddList > -1) {
        currentFieldAddList[indexInFieldAddList].itemList = newItemList;
        props.setFieldAddList(currentFieldAddList);
    }

    // Update in fieldList
    let currentFieldList = cloneDeep(props.fieldList);
    let indexInFieldList = Utils.findIndexInArrayById(currentField.id, currentFieldList);
    if (indexInFieldList > -1) {
        currentFieldList[indexInFieldList].itemList = newItemList;
        props.setFieldList(currentFieldList);
    }
    props.setPanelScreen(props.parentPanelScreen);
    props.setIsChangeData(true);
};

/**
 * add status item
 * @param {*} argsAll
 */
export const addStatusItem = (argsAll, event) => {
    // a return event occured
    if (event.detail === 0) {
        return;
    }

    const newItem = {
        id: Date.now().toString(),
        name: {
            jp: {
                A: 'F',
                text: '',
            },
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: '',
            },
        },
        structure: {
            helpdesk: {
                color: itemStatusColor[0].color,
                background: itemStatusColor[0].background,
            },
            customer: {
                color: itemStatusColor[0].color,
                background: itemStatusColor[0].background,
            },
            no: argsAll.itemList.length + 1,
            isUsingItem: true,
        },
        isShowInfo: true,
        isErrorValidate: false,
        errorMsg: {},
    };

    let newItemList = [...argsAll.itemList, newItem];
    argsAll.setItemList(newItemList);
};

/**
 * onChangeItemName
 * @param {*} event
 * @param {*} index
 * @param {*} argsAll
 */
export const onChangeItemName = (event, index, argsAll) => {
    event.preventDefault();
    let textValue = event.target.value;
    let itemList = cloneDeep(argsAll.itemList);

    if (!Utils.isEmptyArray(itemList)) {
        // Update item list data
        let currentItemList = [...itemList];
        let newItemName = { ...currentItemList[index].name };
        newItemName[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: textValue,
        };
        currentItemList[index].name = newItemName;
        // currentItemList[index].isAutoFocusItemName = true;
        // currentItemList[index].isAutoFocusCustmerView = false;

        let validateItemName = validateStatusItemName(textValue);
        if (!Utils.isEmptyObject(validateItemName)) {
            currentItemList[index].errorMsg['name'] = validateItemName.message;
        } else if (currentItemList[index].hasOwnProperty('errorMsg')) {
            currentItemList[index].errorMsg['name'] = '';
        }
        argsAll.setItemList(currentItemList);
    }
};

/**
 * validateStatusItemName
 * @param {*} value 
 * @returns 
 */
export const validateStatusItemName = (value) => {
    let errors = {};
    value = value.trim();

    if (Utils.isEmptyString(value)) {
        errors = {
            message: I18n.get('STAMSG001'),
            type: 'require',
        };
    } else {
        if (value.length > 20) {
            errors = {
                message: '20文字以下で入力してください。',
                type: 'maxLength',
            };
        } else {
            errors = {};
        }
    }

    return errors;
}

/**
 * onChangeCustomerView name
 * @param {*} event
 * @param {*} index
 */
export const onChangeCustomerView = (event, index, argsAll) => {
    let textValue = event.target.value.trim();

    if (!Utils.isEmptyArray(argsAll.itemList)) {
        // Update item list data
        let currentItemList = cloneDeep(argsAll.itemList);
        let newViewForCustomer = { ...currentItemList[index].viewForCustomer };
        newViewForCustomer[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: textValue,
        };
        currentItemList[index].viewForCustomer = newViewForCustomer;
        // currentItemList[index].isAutoFocusCustmerView = true;
        // currentItemList[index].isAutoFocusItemName = false;
        let msgErr = '';
        if (textValue && textValue.length > 20) {
            msgErr = '20文字以下で入力してください。';
        } else {
            currentItemList[index].errorMsg['viewForCustomer'] = '';
        }

        if (msgErr) {
            if (currentItemList[index].hasOwnProperty('errorMsg')) {
                currentItemList[index].errorMsg['viewForCustomer'] = msgErr;
            } else {
                currentItemList[index].errorMsg = {
                    viewForCustomer: msgErr,
                };
            }
        }

        argsAll.setItemList(currentItemList);
    }
};

/**
 * showItemInfo
 * @param {*} index
 */
export const showItemInfo = (index, argsAll) => {
    if (!Utils.isEmptyArray(argsAll.itemList)) {
        // Update item list data
        let currentItemList = cloneDeep(argsAll.itemList);
        currentItemList[index].isShowInfo = currentItemList[index].isShowInfo ? false : true;
        argsAll.setItemList(currentItemList);
    }
};

/**
 *
 * @param {*} event
 * @param {*} index
 * @returns
 */
export const onKeyPressItemName = (event, index, argsAll) => {
    if (event.key !== 'Enter') {
        return;
    }

    showItemInfo(index, argsAll);
};

/**
 * select item color
 * @param {*} type
 * @param {*} itemColor
 * @param {*} argsAll
 * @returns
 */
export const selectItemColor = (type, itemColor, argsAll) => {
    argsAll.setNameStylePopover(null);
    argsAll.setCustomerNameStylePopover(null);

    let itemList = cloneDeep(argsAll.itemList);
    if (
        Utils.isEmptyArray(itemList) ||
        !['helpdesk', 'customer'].includes(type) ||
        argsAll.updateStyleIndex === -1
    ) {
        return;
    }

    let currentItemList = [...itemList];
    let currentItemStructure = { ...currentItemList[argsAll.updateStyleIndex].structure };
    let objStyle = {
        color: itemColor.color,
        background: itemColor.background,
    };
    if (type === 'helpdesk') {
        // update name color and bg
        currentItemStructure.helpdesk = objStyle;
    } else {
        // update customer name color and bg
        currentItemStructure.customer = objStyle;
    }
    currentItemList[argsAll.updateStyleIndex].structure = currentItemStructure;
    argsAll.setItemList(currentItemList);
};

/**
 * removeItem
 * @param {*} item
 * @param {*} argsAll
 */
export const removeItem = (item, argsAll) => {
    // Update item list
    if (!Utils.isEmptyArray(argsAll.itemList)) {
        let currentItemList = cloneDeep(argsAll.itemList);
        let index = Utils.findIndexInArrayById(item.id, currentItemList);
        if (index !== -1) {
            currentItemList.splice(index, 1);
            argsAll.setItemList(currentItemList);
        }
    }

    // update item list default
    if (!Utils.isEmptyArray(argsAll.itemListDefault)) {
        let currentItemListDefault = cloneDeep(argsAll.itemListDefault);
        let indexInListDefault = Utils.findIndexInArrayById(item.id, currentItemListDefault);
        if (indexInListDefault !== -1) {
            currentItemListDefault.splice(indexInListDefault, 1);
            argsAll.setItemListDefault(currentItemListDefault);
        }
    }

    // update item list created
    if (!Utils.isEmptyArray(argsAll.createdItemList)) {
        let currentCreatedItemList = cloneDeep(argsAll.createdItemList);
        let indexInListDefault = Utils.findIndexInArrayById(item.id, currentCreatedItemList);
        if (indexInListDefault !== -1) {
            currentCreatedItemList.splice(indexInListDefault, 1);
            argsAll.setCreatedItemList(currentCreatedItemList);
        }
    }

    // update item list using
    if (!Utils.isEmptyArray(argsAll.itemUsingList)) {
        let currentItemUsingList = cloneDeep(argsAll.itemUsingList);
        let indexInListDefault = Utils.findIndexInArrayById(item.id, currentItemUsingList);
        if (indexInListDefault !== -1) {
            currentItemUsingList.splice(indexInListDefault, 1);
            argsAll.setItemUsingList(currentItemUsingList);
        }
    }
};

/**
 * delete inactive item
 * @param {*} item 
 * @param {*} argsAll 
 * @param {*} props 
 * @returns 
 */
export const deleteInactiveItem = async (item, argsAll, props) => {
    if (!item || Utils.isEmpty(item) || item.structure.isUsingItem) {
        return;
    }

    props.setIsLoading(true);
    let deleteItem = await deleteForm(props?.API, item.id);

    if (!deleteItem) {
        let errList = deleteItem?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            props.enqueueSnackbar(I18n.get(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }
        props.setIsLoading(false);
        return;
    }

    argsAll.setIsDeleteItem(true);
    removeItemInParentState(props, argsAll, item);
    props.setIsLoading(false);
}


/**
 * remove item in field list screen
 * @param {*} props 
 * @param {*} argsAll 
 * @param {*} item 
 * @returns 
 */
export const removeItemInParentState = (props, argsAll, item) => {
    let fieldData = {};

    // update fieldAddList state in field list screen
    let fieldAddList = cloneDeep(props.fieldAddList);
    let indexInFieldAddList = Utils.findIndexInArrayById(argsAll.currentField.id, fieldAddList);
    if (indexInFieldAddList === -1) {
        return;
    }
    fieldData = cloneDeep(fieldAddList[indexInFieldAddList]);
    fieldData.defaultItemList = Utils.removeItemInArrayById(item.id, cloneDeep(fieldData.defaultItemList));
    fieldData.itemList = Utils.removeItemInArrayById(item.id, cloneDeep(fieldData.itemList));
    fieldAddList.splice(indexInFieldAddList, 1, fieldData);
    props.setFieldAddList(fieldAddList);

    // update current update field state
    let currentUpdateField = cloneDeep(props.currentUpdateField);
    if (!Utils.isEmptyObject(currentUpdateField) && fieldData.id === currentUpdateField.id) {
        props.setCurrentUpdateField(fieldData);
    }

    // update fieldListInState state in field list screen
    let fieldListInState = cloneDeep(props.fieldListInState);
    let indexInFieldListInState = Utils.findIndexInArrayById(fieldData.id, fieldListInState);
    if (indexInFieldListInState !== -1) {
        fieldListInState.splice(indexInFieldListInState, 1, fieldData);
        props.setFieldListInState(fieldListInState);
    }

    // Update fieldLisForUpdate state in field list screen
    let fieldLisForUpdate = cloneDeep(props.fieldLisForUpdate);
    if (fieldLisForUpdate.hasOwnProperty(fieldData.id)) {
        fieldLisForUpdate[fieldData.id] = fieldData;
        props.setFieldLisForUpdate = fieldLisForUpdate;
    }
}


/**
 * isChangeItemListData
 * @param {*} itemList 
 * @param {*} itemListDefault 
 * @returns status change
 */
export const isChangeItemListData = (itemList, itemListDefault) => {
    if (Utils.isEmptyArray(itemList) && Utils.isEmptyArray(itemListDefault)) {
        return false;
    }

    if (itemList.length !== itemListDefault.length) {
        return true;
    }

    let isChange = false;

    for (const item of itemList) {
        let indexExist = Utils.findIndexInArrayById(item.id, itemListDefault);
        if (indexExist === -1) {
            isChange = true;
        } else {
            let itemDefault = itemListDefault[indexExist];

            isChange = !(
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name) ===
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, itemDefault.name) && //compare name
                Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.viewForCustomer) ===
                Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    itemDefault.viewForCustomer
                ) && //compare customer name
                item.structure.no === itemDefault.structure.no && // compare number
                item.structure.isUsingItem === itemDefault.structure.isUsingItem && // compare isUsingItem
                _.isEqual(item.structure.helpdesk, itemDefault.structure.helpdesk) && // compare helpdesk data
                _.isEqual(item.structure.customer, itemDefault.structure.customer) // compare helpdesk data
            )
        }

        // if isDisable false then break
        if (isChange) {
            break;
        }
    }

    return isChange;
}


/**
 * sortStatusItemListByStructure
 * @param {*} itemList 
 * @returns 
 */
export const sortStatusItemListByStructure = (itemList) => {
    if (Utils.isEmptyArray(itemList)) return [];

    return itemList.sort((item1, item2) => {
        let item1No = Utils.convertJSONDataToObject(item1.structure).no || 0;
        let item2No = Utils.convertJSONDataToObject(item2.structure).no || 0;
        return item1No - item2No;
    });
}